import store from 'client/store';

export default function onboardingRouteGuard(to, from, next, storeInstance = store) {
  const { path } = to;
  const showOnboarding = storeInstance.getters['OnboardingModule/getShowOnboarding'];
  let route;

  if (path.indexOf('/logout') === 0) {
    next();
    return;
  }

  if (path.indexOf('/onboarding') === 0 && (!showOnboarding)) {
    route = '/discover';
  }

  next(route);
}
